export type ModalityIncludeKind =
    | 'room'
    | 'merienda'
    | 'cleaning_room'
    | 'cleaning_terrace'
    | 'decoration'
    | 'monitor'
    | 'generic';

export interface ModalityIncludeItem {
    kind: ModalityIncludeKind;
    label: string;
}

function normalize(text: string): string {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

export function resolveIncludeKind(label: string): ModalityIncludeKind {
    const value = normalize(label);

    if (value.includes('terraza')) return 'cleaning_terrace';
    if (value.includes('limpieza') || value.includes('cleaning')) return 'cleaning_room';
    if (value.includes('merienda') || value.includes('snack')) return 'merienda';
    if (value.includes('decor')) return 'decoration';
    if (value.includes('monitor')) return 'monitor';
    if (
        value.includes('sala') ||
        value.includes('privada') ||
        value.includes('equipada') ||
        value.includes('alquiler')
    ) {
        return 'room';
    }

    return 'generic';
}

/** Short label for the icon row under INCLUYE. */
export function shortenIncludeLabel(label: string): string {
    const value = normalize(label);
    const kind = resolveIncludeKind(label);

    if (kind === 'merienda') {
        const unitsMatch = label.match(/(\d+)\s*unidades/i);
        if (unitsMatch) {
            return `Merienda (hasta ${unitsMatch[1]})`;
        }
        return 'Merienda';
    }
    if (kind === 'cleaning_terrace') return 'Limpieza Terraza';
    if (kind === 'cleaning_room') return 'Limpieza de Sala';
    if (kind === 'decoration') {
        return value.includes('basic') ? 'Decoración Básica' : 'Decoración';
    }
    if (kind === 'monitor') return 'Monitor';
    if (kind === 'room') {
        if (label.length <= 28) return label;
        return 'Sala privada';
    }

    return label.length > 22 ? `${label.slice(0, 20)}…` : label;
}

export function toIncludeItems(labels: string[]): ModalityIncludeItem[] {
    return labels.map((label) => ({
        kind: resolveIncludeKind(label),
        label: shortenIncludeLabel(label),
    }));
}
